import { render, staticRenderFns } from "./newGoods.vue?vue&type=template&id=41a903dd&scoped=true"
import script from "./newGoods.vue?vue&type=script&lang=js"
export * from "./newGoods.vue?vue&type=script&lang=js"
import style0 from "./newGoods.vue?vue&type=style&index=0&id=41a903dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a903dd",
  null
  
)

export default component.exports